import { cn } from '@/lib/cn'
import type { MccInfo } from '../types'

const RISK_BG: Record<MccInfo['risk_tier'], string> = {
  low: 'bg-status-success/10 text-status-success ring-status-success/30',
  medium: 'bg-status-pending/10 text-status-pending ring-status-pending/30',
  high: 'bg-priority-critical/10 text-priority-critical ring-priority-critical/30',
}

/**
 * MCC display: '5411 — Grocery Stores' format. Risk tier colours the badge.
 *
 * Per the technical notes, the description is denormalised onto the
 * transaction payload by the backend — never fetch the lookup per render.
 */
export function MccBadge({ mcc }: { mcc: MccInfo }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-sm px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        RISK_BG[mcc.risk_tier],
      )}
      title={`Risk tier: ${mcc.risk_tier}`}
    >
      <span className="font-mono">{mcc.code}</span>
      <span aria-hidden>—</span>
      <span>{mcc.description}</span>
    </span>
  )
}
